export default "__VITE_ASSET__d3d1c020__"